import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import queryString from 'query-string';
import config from 'src/config'
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig'

class Privacy extends React.Component {
  render() {   
    let title = domainConfig.title;
    let url = location.protocol+"//"+location.host;
    return (
      <div class="terms container p-5" lang="EN-US" link="blue" vlink="purple"> 
        <div class="Section1">
          <h5 class="text-center">Privacy Policy</h5>
          <p>
            This Privacy Policy governs the manner in which {title} collects, uses, maintains and discloses information 
            collected from users (each, a "User") of the {url} website ("Site") 
            and any applicable Software (collectively, the "Service"). 
            This privacy policy applies to the Service and all products and services offered by {title}.          
          </p> 
          <div>
            <h6>Personal identification information.</h6>
            <p>            
              We may collect personal identification information from Users in a variety of ways, 
              including, but not limited to, when Users visit our site, register on the site, subscribe to the newsletter, 
              respond to a survey, and in connection with other activities, services, features or resources 
              we make available on our Service. Users may be asked for, as appropriate, name, email address. 
              Users may, however, visit our Service anonymously. 
              We will collect personal identification information from Users only if they voluntarily submit such information to us. 
              Users can always refuse to supply personally identification information, 
              except that it may prevent them from engaging in certain Service related activities.
            </p> 
          </div>
          <div>
            <h6>Non-personal identification information.</h6>
            <p>            
              We may collect non-personal identification information about Users whenever they interact with our Service. 
              Non-personal identification information may include the browser name, 
              the type of computer and technical information about Users means of connection to our Service, 
              such as the operating system and the Internet service providers utilized and other similar information.
            </p> 
          </div>
          <div>
            <h6>Web browser cookies.</h6>
            <p>            
              Our Service may use "cookies" to enhance User experience. 
              User's web browser places cookies on their hard drive for record-keeping purposes and sometimes 
              to track information about them. 
              User may choose to set their web browser to refuse cookies, 
              or to alert you when cookies are being sent. 
              If they do so, note that some parts of the Service may not function properly.
            </p> 
          </div>
          <div>
            <h6>How we use collected information.</h6>
            <div>
              {title} may collect and use Users personal information for the following purposes:
            </div>
            <ul>
              <li>To improve customer service Information you provide helps us respond to your customer service requests and support needs more efficiently.</li>
              <li>To personalize user experience We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Service.</li>
              <li>To send periodic emails</li>
            </ul>          
            <p>           
              We may use the email address to send User information and updates pertaining to their order. 
              It may also be used to respond to their inquiries, questions, and/or other requests. 
              If User decides to opt-in to our mailing list, they will receive emails that may include company news, updates, 
              related product or service information, etc. 
              If at any time the User would like to unsubscribe from receiving future emails, 
              we include detailed unsubscribe instructions at the bottom of each email or User may contact us via our Service.          
            </p> 
          </div>
          <div>
            <h6>How we protect your information.</h6>
            <p>              
              We adopt appropriate data collection, storage and processing practices and security measures 
              to protect against unauthorized access, alteration, disclosure or destruction of your personal information, 
              username, password, transaction information and data stored on our Service. 
              Sensitive and private data exchange between the Service and its Users happens over a SSL secured communication channel 
              and is encrypted and protected with digital signatures.
            </p> 
          </div> 
          <div>
            <h6>Sharing your personal information.</h6>      
            <p>              
              We do not sell, trade, or rent Users personal identification information to others. 
              We may share generic aggregated demographic information not linked to any personal identification information 
              regarding visitors and users with our business partners, 
              trusted affiliates and advertisers for the purposes outlined above.
              We may use third party service providers to help us operate our business and the Service or administer activities 
              on our behalf, such as sending out newsletters or surveys. 
              We may share your information with these third parties for those limited purposes provided 
              that you have given us your permission.
            </p>
          </div>
          <div>
            <h6>Changes to this privacy policy.</h6>
            <p>              
              {title} has the discretion to update this privacy policy at any time. 
              When we do, we will post a notification on the main page of our Service and send you an email. 
              We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect 
              the personal information we collect. 
              You acknowledge and agree that it is your responsibility to review this privacy policy periodically 
              and become aware of modifications.
            </p>
          </div>
          <div>
            <h6>Your acceptance of these terms.</h6>
            <p>              
              By using this Service, you signify your acceptance of this policy and terms of service. 
              If you do not agree to this policy, please do not use our Service. 
              Your continued use of the Service following the posting of changes to this policy will be deemed 
              your acceptance of those changes.
            </p>
          </div>
          <div>
            <h6>Contacting us</h6>
            <p>              
              If you have any questions about this Privacy Policy, the practices of this site, 
              or your dealings with this site, please contact us at: 
              contact at {title} dot com or using the live chat from our website {url}
            </p> 
          </div>
          <div>  
            <p>
              <i>This document was last updated on November 06, 2014</i>
            </p>                                                                                     
          </div>
        </div> 
      </div> 
    )
  }
}
export default Privacy;